import styled from '@emotion/styled';

const Container = styled.div`
  margin-top: 3rem;
`;

export const StyledFilters = {
  Container,
};
